import AdminOnly from 'layout/AdminOnly';
import DashboardApi from 'api/dashboard';
import DataTable from '../dataTable';
import events from 'lib/events';
import FollowUpApi from 'api/followUp';
import LayoutSelect from '../forms/layoutSelect';
import Loader from '../loader';
import moment from 'moment';
import phoneFormat from 'util/phoneformat';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import StackedBarChart from '../charts/stackedBarChart';
import ToolTip, {tooltipPositions} from '../ToolTip';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {problemSelectFields} from 'helpers/problemHelpers';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

class ProblemFollowUp extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
    timeframe: PropTypes.string.isRequired,
    branchesFull: PropTypes.any,
  };

  static defaultProps = {
    timeframe: 'month',
  };

  constructor(props) {
    super(props);
    this.state = {
      graph: null,
      report: null,
      loaded: false,
      table: null,
      filters: {
        poolType: null,
      },
      detailFilters: {
        date: null,
        problem: 'All',
        system: 'All',
        tester: 'All',
      },
    };
  }

  componentWillMount() {
    this.onUpdate();
    this.setState({
      stores: this.props.branchesFull,
    });

    this.localeBind = events.subscribe('locale.changed', this.onUpdate);
  }

  componentDidUpdate(prevProps) {
    const {timeframe, branch} = this.props;

    if (prevProps.timeframe !== timeframe || prevProps.branch !== branch) {
      this.onUpdate();
    }
  }

  componentWillUnmount() {
    this.setState({
      graph: null,
      report: null,
      loaded: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    if (this.localeBind && this.localeBind.remove) {
      this.localeBind.remove();
    }
  }

  onUpdate = () => {
    const {start, end, branch, branches, timeframe} = this.props;
    let {formatMessage} = this.props.intl;

    const conditionalPush = (condition, list, pushValue) => {
      if (condition) {
        list.push(pushValue);
      }
    };

    this.setState({
      report: null,
      graph: null,
      loaded: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getFollowUp(branch === -1 ? branches : branch, start, end, timeframe)))
      .then(data => {
        if (data.report) {
          for (let row of data.report) {
            row.FullName = row.NameFirst + ' ' + row.NameLast;
            let problems = [];
            //Created string list of all problems of follow-up

            conditionalPush(row.Cloudy, problems, formatMessage({id: 'general.cloudy'}));
            conditionalPush(row.Hazy, problems, formatMessage({id: 'general.hazy'}));
            conditionalPush(row.Foaming, problems, formatMessage({id: 'preferences.foaming'}));
            conditionalPush(row.BlackAlgae, problems, formatMessage({id: 'general.black.algae'}));
            conditionalPush(row.GreenAlgae, problems, formatMessage({id: 'general.green.algae'}));
            conditionalPush(row.MustardAlgae, problems, formatMessage({id: 'general.mustard.algae'}));
            conditionalPush(row.SpaAlgae, problems, formatMessage({id: 'general.algae'}));
            conditionalPush(row.SlimeMold, problems, formatMessage({id: 'scan.slime.mold'}));
            conditionalPush(row.Swampy, problems, formatMessage({id: 'preferences.swampy'}));
            conditionalPush(row.CopperStaining, problems, formatMessage({id: 'scan.copper.staining'}));
            conditionalPush(row.IronStaining, problems, formatMessage({id: 'scan.iron.staining'}));
            conditionalPush(row.UnknownStaining, problems, formatMessage({id: 'scan.unknown.staining'}));
            conditionalPush(row.ScaleBuildup, problems, formatMessage({id: 'scan.scale.buildup'}));
            conditionalPush(row.WaterlineBuildup, problems, formatMessage({id: 'scan.waterline.buildup'}));
            conditionalPush(row.OrganicStaining, problems, formatMessage({id: 'scan.organic.staining'}));
            conditionalPush(row.ChlorineDemand, problems, formatMessage({id: 'general.chlorine.demand'}));
            row.Problems = problems.join(', ');
            row.HomePhone = row.HomePhone ? phoneFormat(row.HomePhone) : '';
            row.FollowedUp = row.FollowedUp ? moment.utc(row.FollowedUp).format(dateTimeFormats.numeralDate) : '';
            row.Dismissed = row.Dismissed ? moment.utc(row.Dismissed).format(dateTimeFormats.numeralDate) : '';
            row.Created = row.Created ? moment.utc(row.Created).format(dateTimeFormats.numeralDate) : '';
          }
        }

        (data.graph || []).forEach(g => {
          if (!g.type) {return;}

          g.type = this.props.intl.formatMessage({id: g.type});
        });

        this.setState({
          report: data.report,
          graph: data.graph,
          loaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  }

  getDataRows() {
    const {graph} = this.state;

    if (!graph || graph.length < 1) {
      return null;
    }
    const newData = {
      'open': {
        title: this.props.intl.formatMessage({id: 'general.opened'}),
        boxClass: 'orange-box',
        algae: 0,
        water: 0,
        surface: 0,
        chlorine: 0,
      },
      'called': {
        title: this.props.intl.formatMessage({id: 'general.called'}),
        boxClass: 'green-box',
        algae: 0,
        water: 0,
        surface: 0,
        chlorine: 0,
      },
      'dismissed': {
        title: this.props.intl.formatMessage({id: 'general.dismissed'}),
        boxClass: 'light-blue-box',
        algae: 0,
        water: 0,
        surface: 0,
        chlorine: 0,
      },
    };

    graph.forEach(f => {
      if (f.type === 'Algae') {
        newData.called.algae += f.called;
        newData.open.algae += f.open;
        newData.dismissed.algae += f.dismissed;
      } else if (f.type === 'Water Clarity') {
        newData.called.water += f.called;
        newData.open.water += f.open;
        newData.dismissed.water += f.dismissed;
      } else if (f.type === 'Chlorine Demand') {
        newData.called.chlorine += f.called;
        newData.open.chlorine += f.open;
        newData.dismissed.chlorine += f.dismissed;
      } else if (f.type === 'Surface Problems') {
        newData.called.surface += f.called;
        newData.open.surface += f.open;
        newData.dismissed.surface += f.dismissed;
      }
    });

    const data = [];

    for (let key of Object.keys(newData)) {
      data.push([
        <div key={`${key}.title`}
             className='tc'><i className={'color-box ' + newData[key].boxClass}/>{newData[key].title}</div>,
        <div key={`${key}.algae`}
             className='tc'>{newData[key].algae}</div>,
        <div key={`${key}.water`}
             className='tc'>{newData[key].water}</div>,
        <div key={`${key}.surface`}
             className='tc'>{newData[key].surface}</div>,
        <div key={`${key}.chlorine`}
             className='tc'>{newData[key].chlorine}</div>,
      ]);
    }

    let algaeTotal = 0;
    let waterTotal = 0;
    let surfaceTotal = 0;
    let chlorineTotal = 0;

    for (let i of Object.keys(newData)) {
      algaeTotal += newData[i].algae;
      waterTotal += newData[i].water;
      surfaceTotal += newData[i].surface;
      chlorineTotal += newData[i].chlorine;
    }

    //add placeholder spacer row
    data.push([
      <div key='ph0'
           className='tc'/>,
      <div key='ph1'
           className='tc'/>,
      <div key='ph2'
           className='tc'/>,
      <div key='ph3'
           className='tc'/>,
      <div key='ph4'
           className='tc'/>,
    ]);
    data.push([
      <div key='total'
           className='tc'>TOTAL</div>,
      <div key='total.algae'
           className='tc'>{algaeTotal}</div>,
      <div key='total.water'
           className='tc'>{waterTotal}</div>,
      <div key='total.surface'
           className='tc'>{surfaceTotal}</div>,
      <div key='total.chlorine'
           className='tc'>{chlorineTotal}</div>,
    ]);

    return data;
  }

  getHeaderRow() {
    const {graph} = this.state;

    if (!graph || graph.length < 1) {
      return null;
    }

    return [
      <div key='header.empty'
           className='tc'/>,
      <div key='header.algea'
           className='tc'><FormattedMessage id='general.algae'/></div>,
      <div key='header.clarity'
           className='tc'><FormattedMessage id='general.water.clarity'/></div>,
      <div key='header.surface'
           className='tc'><FormattedMessage id='general.surface.problems'/></div>,
      <div key='header.cd'
           className='tc'><FormattedMessage id='general.chlorine.demand'/></div>,
    ];
  }

  changeRevertClass(event) {
    event.target.classList.toggle('bl-revert');
    event.target.classList.toggle('bl-revert-over');
  }

  clickedDismiss(id) {
    FollowUpApi.dismiss(id)
      .then(() => {
        this.state.report.find(x => x.ID === id)['Dismissed'] = moment.utc().format(dateTimeFormats.numeralDate);
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }

  clickedFollowUp(id) {
    FollowUpApi.followUp(id)
      .then(() => {
        this.state.report.find(x => x.ID === id)['FollowedUp'] = moment.utc().format('M/DD/YYYY');
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }

  clickedRevert(id) {
    FollowUpApi.revert(id)
      .then(() => {
        let report = this.state.report.find(x => x.ID === id);

        report['FollowedUp'] = '';
        report['Dismissed'] = '';
        this.setState({report: this.state.report});
      })
      .catch(error => events.publish('error.user', error));
  }

  detailedView() {
    let {formatMessage} = this.props.intl;
    const reports = this.state.report.filter(r => {
      let filters = this.state.detailFilters;

      if ((filters.problem === 'All' || r.Problems.indexOf(filters.problem) !== -1) &&
        (filters.tester === 'All' || r.Tester.indexOf(filters.tester) !== -1) &&
        (filters.system === 'All' || r.TypeID === parseInt(filters.system))) {
        return r;
      }
      return null;
    });

    return <div>
      <div className='report-filter-block row'>
        <div className='col-sm-2 extra-margin-hack'>
          <LayoutSelect
            label={formatMessage({id: 'general.system'})}
            value={this.state.detailFilters.system}
            dataKey='system'
            keys={['All', 1, 2, 3]}
            options={[
              formatMessage({id: 'general.all'}),
              formatMessage({id: 'general.pool'}),
              formatMessage({id: 'general.spa'}),
              formatMessage({id: 'general.swim.spa'}),
            ]}
            editMode={true}
            dataChanged={this.updateDetailFilter}/>
        </div>
        <div className='col-sm-2 extra-margin-hack'>
          <LayoutSelect
            label={formatMessage({id: 'general.problem'})}
            value={this.state.detailFilters.problem}
            dataKey='problem'
            keys={problemSelectFields.map(s => s.id)}
            options={problemSelectFields.map(s => formatMessage({id: s.name}))}
            editMode={true}
            dataChanged={this.updateDetailFilter}/>
        </div>
        <div className='col-sm-2 extra-margin-hack'>
          <LayoutSelect
            label={formatMessage({id: 'general.tester'})}
            value={this.state.detailFilters.tester}
            dataKey='tester'
            keys={['All', ...new Set(this.state.report.map(r => r.Tester))]}
            options={[formatMessage({id: 'general.all'}), ...new Set(this.state.report.map(r => r.Tester))]}
            editMode={true}
            dataChanged={this.updateDetailFilter}/>
        </div>
        <div className='col-sm-2'>
          <div className='form-group'>
            <label><FormattedMessage id='posdashboard.total.customers'/></label>
            <div className='medium-blue-text'>{reports.length}</div>
          </div>
        </div>
      </div>
      <table className='table-biolab table-striped table-biolab-right-headers'>
        <thead>
          <tr>
            <th><FormattedMessage id='general.primary.contact'/></th>
            <th><FormattedMessage id='general.primary.phone'/></th>
            <th style={{width: '150px'}}><FormattedMessage id='general.problem'/></th>
            <th><FormattedMessage id='general.last.analysis.date'/></th>
            <th><FormattedMessage id='general.water.tester'/></th>
            <th style={{width: '120px'}}>
              <FormattedMessage id='posdashboard.email.status'/>
              <ToolTip title={formatMessage({id: 'general.email.status.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly
                     invert/>
            </th>
            <th style={{paddingLeft: '13px'}}>
              <FormattedMessage id='general.click.to'/><br/><FormattedMessage id='general.followup'/>
              <ToolTip body={<p><FormattedMessage id='general.followup.tooltip.one'/> <i className='bl bl-follow-up'/>
                <FormattedMessage id='general.followup.tooltip.two'/> <i className='bl bl-dismiss'/>
                <FormattedMessage id='general.followup.tooltip.three'/> <i className='bl bl-revert'/>
                <FormattedMessage id='general.followup.tooltip.four'/></p>}
                     position={tooltipPositions.topRight}
                     iconOnly
                     invert/>
            </th>
          </tr>
        </thead>
        <tbody>
          {
          reports.map(row => {
            let customerLink = `#customer/${row.CustomerID}`;
            let analysisLink = `#customer/${row.CustomerID}/${row.PoolID}/analysis/report/${row.AnalysisID}`;

            return <tr key={row.ID}>
              <td>
                <a href={customerLink}>{row.FullName}</a>
              </td>
              <td>{row.HomePhone}</td>
              <td>{row.Problems}</td>
              <td>
                <a href={analysisLink}>{row.Created}</a>
              </td>
              <td>{row.Tester}</td>
              <td>
                {this.emailColumn(row)}
              </td>
              <td>
                {this.hasFollowedUpOrDismissed(row)}
              </td>
            </tr>;
          })
        }
        </tbody>
      </table>
    </div>;
  }

  emailColumn(report) {
    let FollowUpDate = report['FollowUpDate'] ? moment.utc(report['FollowUpDate']) : '';

    if (!report.Email || report.Email.trim() === '') {
      return <div><i className='bl bl-attention red'/> <FormattedMessage id='general.no.email'/></div>;
    }
    if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
      return <div><i className='bl bl-attention red'/> <FormattedMessage id='general.email.not.sent'/></div>;
    }
    if (!report['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
      return <div><i className='bl bl-opted-out'/> <FormattedMessage id='general.email.opted.out'/></div>;
    }
    return <div>{FollowUpDate.format(dateTimeFormats.numeralDate)}</div>;
  }

  hasFollowedUpOrDismissed(report) {
    let revert = <i className={'bl fa-2x pointer bl-revert revert-selector'}
                    onMouseOver={this.changeRevertClass}
                    onMouseLeave={this.changeRevertClass}
                    onClick={this.clickedRevert.bind(this, report['ID'])}/>;

    if (report['FollowedUp']) {
      return <span className='follow-up-summary'><i className='bl bl-called'/> {report['FollowedUp']} {revert}</span>;
    }
    if (report['Dismissed']) {
      return <span className='follow-up-summary'><i className='bl bl-cancel'/> {report['Dismissed']} {revert}</span>;
    }
    let f = <i className='bl fa-2x bl-follow-up pointer'
               onClick={this.clickedFollowUp.bind(this, report['ID'])}/>;
    let d = <i className='bl fa-2x bl-dismiss pointer'
               onClick={this.clickedDismiss.bind(this, report['ID'])}/>;

    return <div>{f}{d}</div>;
  }

  updateDetailFilter = event => {
    const detailFilters = this.state.detailFilters;

    detailFilters[event.key] = event.value;
    this.setState({detailFilters: detailFilters});
  };

  render() {
    const {graph, report, loaded} = this.state;
    const {timeframe} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='problem-follow-up expanded-tile'>
      <Loader loaded={loaded}>
        <div>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='report-header'>
                <AdminOnly>
                  <a className='dashboard-report-view-link pull-right'
                     href='#reports/followups/problem-follow-ups'>
                    <span className='underline'><FormattedMessage id='general.view.report'/></span>
                    <i className='bl bl-right_arrow'/></a>
                </AdminOnly>
                <h2 className='title'><FormattedMessage id='posdashboard.problem.followups'/></h2>
                <hr/>
              </div>
            </div>
          </div>
          { // Only show graph  when user select Year-To-Date
            timeframe === 'year' && graph ?
              <div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='report-graph'>
                      <StackedBarChart data={graph}
                                       verticalAxisTitle={formatMessage({id: 'posdashboard.number.followups'})}
                                       colors={['#e17155', '#93cb4d', '#5cbae4']}
                                       titleField='type'
                                       valueFields={['open', 'called', 'dismissed']}
                                       valueTitles={[
                                         formatMessage({id: 'posdashboard.open.followups'}),
                                         formatMessage({id: 'posdashboard.called.followups'}),
                                         formatMessage({id: 'posdashboard.dismissed.followups'}),
                                       ]}
                                       fixedColumnWidth={100}
                                       fillAlphas={0.75}
                      />
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='table-water-total table-biolab table-dashboard'>
                      <DataTable headerRow={this.getHeaderRow()}
                                 data={this.getDataRows()}/>
                    </div>
                  </div>
                </div>
              </div> :
              <div>
                {report ? this.detailedView() : <div/>}
              </div>
          }
        </div>
      </Loader>
    </div>;
  }
}


export default injectIntl(bindLocaleUpdate(ProblemFollowUp));
